const getLineItemPrice = (priceObj)=>{
    const total = priceObj.total;
    const unit = priceObj.unit;
    return {
        total: {
            discount: total.discount.amount,
            original: total.subtotal,
            gross: total.gross,
            net: total.net,
            taxAmount: total.tax.amount
        },
        unit: {
            discount: unit.discount.amount,
            original: unit.subtotal,
            gross: unit.gross,
            net: unit.net,
            taxAmount: unit.tax.amount
        }
    };
};

export { getLineItemPrice };
//# sourceMappingURL=get-line-item-price.js.map
